import { Controller } from "@hotwired/stimulus"
import { marked } from "marked"
import DOMPurify from "dompurify"

export default class extends Controller {
  static targets = ["source"]

  connect() {
    const raw = this.hasSourceTarget
      ? this.sourceTarget.textContent
      : this.element.dataset.markdownContent || this.element.textContent.trim()

    if (raw) {
      this.element.innerHTML = DOMPurify.sanitize(marked.parse(raw))
      this.element.dataset.rawMarkdown = raw
    }
  }
}
